<ul class="navbar-nav">
  <li class="nav-item">
    <div class="col mx-2">
      <app-notifications></app-notifications>
    </div>
  </li>
</ul>
